// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"a780c34f","488":"29b71886","497":"43932c46","511":"d29306bb","727":"744276f1","892":"ffde6a8f"}[chunkId] + ".chunk.js";
};